"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
const common_1 = require("../../../@inax/common");
const plcWriteTransportPack_1 = require("./transport/plcWriteTransportPack");
const plcEventProxyFactory_1 = require("./internal/plcEventProxyFactory");
let InaxPlcService = InaxPlcService_1 = 
/**
 * Service class to communicate with inax to handle plc access
 * @class InaxPlcService
 * @classdesc Service class to communicate with inax to handle plc access
 * @author insite-gmbh
 */
class InaxPlcService {
    /**
     * constructor.
     * @param {Http} _http http service to handle web api calls.
     * @param {Configuration} _configuration configuration specifies signalRHubs, serveraddress,... .
     * @param {ProfileService} _profileService this service adds authentication data to the webApiRequests.
    */
    constructor(_http, _configuration, _profileService) {
        this._http = _http;
        this._configuration = _configuration;
        this._profileService = _profileService;
    }
    get hubName() {
        return "PlcHub";
    }
    get isHubConnected() {
        if (InaxPlcService_1._connectionStateDelegate != null) {
            let state = InaxPlcService_1._connectionStateDelegate();
            return state == common_1.ConnectionState.Connected;
        }
        return false;
    }
    /***********************************************************************
     *          SIGNALR
     * ********************************************************************/
    /**
     * Initialize SignalR to create the hubProxy and activate the callback from server to client.
     * This mehtod will be called from InaxSignalR
     * @method registerEvents
     * @param {InaxSignalR} signalR Reference to SignalR
     */
    registerEvents(signalR) {
        if (this._configuration.UseSignalR && this._configuration.EnabledSignalRHubs.indexOf(this.hubName) >= 0) {
            InaxPlcService_1._proxyFactory = new plcEventProxyFactory_1.PlcEventProxyFactory(signalR.getHubProxy(this.hubName));
            InaxPlcService_1._connectionStateDelegate = () => signalR.state;
        }
    }
    /**
     * Create a proxy to subscribe to plc data changes of the given variables (initial datachange will be fired after subscription)
     * @method createEventProxy
     * @param {string} group Group name for the callbacks, so you can register variables for this group from different places,
     * and every watcher of this group gets an update
     * @param {string} plcId This id specifies a single plc, the id have to be the same as specified in the
     * INAX config (with different ids you could adress different plcs or connections)
     * @param {string} mapping Mapping name of the Variables. Every symbolic variable has to have a Mapping specification
     * which specifies the area, offset,.. of the variable
     * @param {Array<string>} variables Names of the symbolic/absolute variables
     * @param {boolean} abs Switch between Absolute and Symbolic variables
     * @return {IPlcEventProxy} returns a object with the registered properties to subscribe on changes.
     */
    createEventProxy(group, plcId, mapping, variables, abs = false) {
        if (InaxPlcService_1._proxyFactory == null)
            throw "PlcHub not available or not registered!";
        return InaxPlcService_1._proxyFactory.create(group, plcId, mapping, variables, abs);
    }
    /***********************************************************************
     *          WEB API
     * ********************************************************************/
    /**
     * Read a single variable from the plc
     * @method readSingle
     * @param {string} plcId This id specifies a single plc, the id have to be the same as specified in the
     * INAX config (with different ids you could adress different plcs or connections) .
     * @param {string} mapping Mapping name of the Variables. Every symbolic variable has to have a Mapping specification
     * which specifies the area, offset,.. of the variable.
     * @param {string} variable Names of the variable.
     * @return {Observable<any>} returns a Observable which is called with the red data after the read operation is finished.
     */
    readSingle(plcId, mapping, variable) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "Read") + "?mappingName=" + plcId + "." + mapping + "&variable=" + variable;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    /**
     * Read variables from the plc
     * @method read
     * @param {string} plcId This id specifies a single plc, the id have to be the same as specified in the
     * INAX config (with different ids you could adress different plcs or connections)
     * @param {string} mapping Mapping name of the Variables. Every symbolic variable has to have a Mapping specification
     * which specifies the area, offset,.. of the variable
     * @param {Array<string>} variables Names of the symbolic/absolute variables
     * @return {Observable<any>} returns a Observable which is called with the red data after the read operation is finished.
     */
    read(plcId, mapping, variable) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "Read") + "?mappingName=" + plcId + "." + mapping + "&variable=" + variable.join(",");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    /**
     * Reads the given variables and returns the result as a string
     * @method readToString
     * @param {string} command A read command like this: mapping:variable,variable[,variable=value];
     * @return {Observable<string>} returns a Observable which is called with the red data after the read operation is finished.
     */
    readToString(command) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "ReadToString") + "?command=" + this.normalizeUri(command);
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    /**
     * Reads the given absolut data  e.g. "DB1", "W10"  or  "DB11", "X16_0"  or  "DB2", "S528_10"
     * @method readAbs
     * @param {string} plcId This id specifies a single plc, the id have to be the same as specified in the
     * INAX config (with different ids you could adress different plcs or connections) .
     * @param {string} selector This parameter sets the read area (e.g.
     *  IB -> Input Byte
     *  FB -> Flag Byte
     *  QB -> Output Byte
     *  TM -> Timer
     *  CT -> Counter
     *  DB[number] -> DB)
     * @param {string} variable This parameter specifies the offset and length. (W10 (offset= 10 length = 2byte (W=Word)),
     * X15_0 (offset = 15  bitoffset = 0  length = 1bit), B10 (offset = 10 length = 1Byte), S5_10 (offset = 5  length = 12 (becasue datatype is String,
     * the length of the string is 10 and 2 MetaBytes are in front of a plc string)))
     * @return {Observable<any>} returns a Observable which is called with the red data after the read operation is finished.
     */
    readAbs(plcId, selector, variable) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "ReadAbs") + "?selector=" + plcId + "." + selector + "&variable=" + variable;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    /**
     * Write the given data to the plc
     * @method write
     * @param {string} plcId This id specifies a single plc, the id have to be the same as specified in the
     * INAX config (with different ids you could adress different plcs or connections) .
     * @param {string} mapping Mapping name of the Variables. Every symbolic variable has to have a Mapping specification
     * which specifies the area, offset,.. of the variable.
     * @param {string} variable Names of the variable.
     * @param {string} value The value to write to the plc.
     * @return {Observable<boolean>} returns a Observable which is called with the write state after the write operation is finished.
     */
    write(plcId, mapping, variable, value) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "Write") + "?mappingName=" + plcId + "." + mapping + "&variable=" + variable;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, JSON.stringify(value), { headers }).map(res => res.ok);
    }
    /**
     * Write the given data to the plc
     * @method writeAbs
     * @param {string} plcId This id specifies a single plc, the id have to be the same as specified in the
     * INAX config (with different ids you could adress different plcs or connections) .
     * @param {string} selector Selector of the Variables like DB100. Every symbolic variable has to have a Mapping specification
     * which specifies the area, offset,.. of the variable.
     * @param {string} variable Address of the variable.
     * @param {string} value The value to write to the plc.
     * @return {Observable<boolean>} returns a Observable which is called with the write state after the write operation is finished.
     */
    writeAbs(plcId, selector, variable, value) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "WriteAbs") + "?selector=" + plcId + "." + selector + "&variable=" + variable;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, JSON.stringify(value), { headers }).map(res => res.ok);
    }
    /**
     * Executes a plc write query. For this write operation you can specify a where clause, if that clause matches to true the data will be written, otherwise not.
     * @method writeQuery
     * @param {string} plcId This id specifies a single plc, the id have to be the same as specified in the
     * INAX config (with different ids you could adress different plcs or connections) .
     * @param {string} mapping Mapping name of the Variables. Every symbolic variable has to have a Mapping specification
     * which specifies the area, offset,.. of the variable.
     * @param {Map<any>} keyvaluepair the keys and values to write.
     * @param {string} where This is the were clause, the data will be written only if this parameter matches or it is null
     * @param {string} from mapping name for the where clause.
     * @param {boolean} abs true is the value to write is an address and not a symbolic variable
     * @return {Observable<boolean>} returns a Observable which is called with the write state after the write operation is finished.
     */
    writeQuery(plcId, mapping, keyvaluepair, where = null, from = null, abs = false) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "Write");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        let data = new plcWriteTransportPack_1.PlcWriteTransportPack();
        if (mapping != null && keyvaluepair != null) {
            data.To = plcId + "." + mapping;
            data.Set = keyvaluepair;
            if (where != null && from != null) {
                data.From = plcId + "." + from;
                data.Where = where;
            }
            if (abs != null && abs)
                data.Abs = true;
        }
        return this._http.post(accessUrl, JSON.stringify(data), { headers }).map(res => res.ok);
    }
    /**
     * Write data from a given string command
     * the sharp means absolute adressing
     * @method writeFromString
     * @param {string} command This parameter contains a write command to write the given data to the plc.
     * (e.g.[#]mapping:variable=value[,variable=value]?variable==value,variable=value]; //the sharp means absolute adressing)
     * @return {Observable<boolean>} returns a Observable which is called with the write state after the write operation is finished.
     */
    writeFromString(command) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "WriteFromString") + "?command=" + this.normalizeUri(command);
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, null, { headers }).map(res => res.ok);
    }
    /**
     * Add a mapping to the plc
     * the sharp means absolute adressing
     * @method addMapping
     * @param {IPlcMappingPack} mapping This parameter represents the mappingname and additional parameters for the new mapping which shall be added.
     * @return {Observable<boolean>} returns a Observable which is called with the result state after the operation is finished.
     */
    addMapping(mapping) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "AddMapping");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, JSON.stringify(mapping), { headers }).map(res => res.ok);
    }
    /**
     * Add a plc mapping to INAX
     * @method addMappingFromString
     * @param {string} mapping This parameter represents the mappingname and additional parameters for the new mapping which shall be added.
     * (e.g. mapping: type,selector,offset  or mapping: Plc.MappingName:TypeName,ValueNumber,ValueOffset  or mapping: default.MyMappingName:MyTypeName,DB10,W5)
     * @return {Observable<boolean>} returns a Observable which is called with the result state after the operation is finished.
     */
    addMappingFromString(mapping) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "AddMappingFromString") + "?mapping=" + this.normalizeUri(mapping);
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, null, { headers }).map(res => res.ok);
    }
    /**
     * Remove a plc mapping from INAX
     * @method removeMappingFromString
     * @param {string} mapping This parameter represents the mappingname which shall be removed.
     * @return {Observable<boolean>} returns a Observable which is called with the result state after the operation is finished.
     */
    removeMappingFromString(mapping) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "RemoveMappingFromString") + "?mapping=" + this.normalizeUri(mapping);
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, null, { headers }).map(res => res.ok);
    }
    /**
     * Open connection to a new plc
     * @method connect
     * @param {string} key This parameter represents the connection key for which the connection shall be opened.
     * @param {string} connectionString This parameter contains the connectioparameter for the new connection (IP address, rack, slot, ...)
     * @return {Observable<boolean>} returns a Observable which is called with the result state after the operation is finished.
     */
    connect(key, connectionString) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "Connect") + "?key=" + this.normalizeUri(key);
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, connectionString, { headers }).map(res => res.ok);
    }
    /**
     * Close plc connection with the given key
     * @method disconnect
     * @param {string} key This parameter represents the connection key for which the connection shall be closed.
     * @return {Observable<boolean>} returns a Observable which is called with the result state after the operation is finished.
     */
    disconnect(key) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "Disconnect") + "?key=" + this.normalizeUri(key);
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, null, { headers }).map(res => res.ok);
    }
    /**
     * Close plc connection with the given key
     * @method readBlockInfo
     * @param {string} selector This parameter contains the name of the block for which the information shall be determined. (e.g. DB10, FB1, FC2, ...)
     * @return {Observable<boolean>} returns a Observable which is called with the result information after the operation is finished.
     */
    readBlockInfo(selector) {
        let accessUrl = this._configuration.buildRestUrl(InaxPlcService_1._plcControllerName, "ReadBlockInfo") + this.normalizeUri("?selector=" + selector);
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    normalizeUri(uri) {
        return encodeURIComponent(uri);
    }
};
InaxPlcService._plcControllerName = "Plc";
InaxPlcService._connectionStateDelegate = null;
InaxPlcService = InaxPlcService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        common_1.InaxConfiguration,
        common_1.ProfileService])
], InaxPlcService);
exports.InaxPlcService = InaxPlcService;
var InaxPlcService_1;
